export const isValidLatitude = (num: number): boolean => {
  return isFinite(num) && Math.abs(num) <= 90;
};

export const isValidLongitude = (num: number): boolean => {
  return isFinite(num) && Math.abs(num) <= 180;
};
